export const ROOT_API = process.env.VUE_APP_ROOT_API
export const APP_DEFAULT_LOCALE = process.env.VUE_APP_I18N_LOCALE
export const APP_TITLE = process.env.VUE_APP_TITLE
